import { SearchX, X, Phone } from "lucide-react";
import { DEALER } from "@/data/dealer";
import { gbp } from "@/lib/inventory";

export const ActiveChips = ({ filters, update, toggle, clear }) => {
  const chips = [
    filters.make && { label: filters.make, remove: () => update({ make: "" }) },
    filters.model && { label: filters.model, remove: () => update({ model: "" }) },
    filters.minPrice && { label: `From ${gbp(filters.minPrice)}`, remove: () => update({ minPrice: 0 }) },
    filters.maxPrice && { label: `Up to ${gbp(filters.maxPrice)}`, remove: () => update({ maxPrice: 0 }) },
    ...["fuel", "transmission", "body"].flatMap((k) => filters[k].map((v) => ({ label: v, remove: () => toggle(k, v) }))),
  ].filter(Boolean);
  if (!chips.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 pt-5" data-testid="active-filter-chips">
      {chips.map((c) => (
        <button
          key={c.label}
          type="button"
          onClick={c.remove}
          className="inline-flex items-center gap-1.5 rounded-sm bg-brand-soft px-2.5 py-1.5 text-sm font-semibold text-brand transition-colors hover:bg-brand hover:text-white"
          aria-label={`Remove filter ${c.label}`}
          data-testid={`active-chip-${c.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        >
          {c.label} <X className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      ))}
      <button type="button" onClick={clear} className="link-underline ml-1 text-sm font-semibold text-ink" data-testid="active-chips-clear-all-button">
        Clear all
      </button>
    </div>
  );
};

export const NoResults = ({ clear }) => (
  <div className="rounded-lg border border-dashed border-[#C5CBD4] bg-paper px-6 py-16 text-center sm:py-20" data-testid="no-results">
    <SearchX className="mx-auto h-10 w-10 text-steel" aria-hidden="true" />
    <h2 className="mt-5 font-display text-2xl font-extrabold">No cars match those filters</h2>
    <p className="mx-auto mt-3 max-w-md leading-relaxed text-steel">
      Try widening your price range or removing a filter. Stock changes regularly, so it's also worth giving us a call.
    </p>
    <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
      <button type="button" onClick={clear} className="btn btn-primary" data-testid="no-results-clear-button">
        Clear all filters
      </button>
      <a href={DEALER.phone.href} className="btn btn-outline" data-testid="no-results-call-link">
        <Phone aria-hidden="true" /> Call {DEALER.phone.display}
      </a>
    </div>
  </div>
);
